import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatRowTime } from '../../utils/todayStats';

export default function CallBackQueue({ items, loading }) {
  const navigate = useNavigate();
  const rows = Array.isArray(items) ? items : [];
  const count = rows.length;

  function openLead(row) {
    const path = row.formId
      ? `/leads/${row.formId}?conversation=${row.id}`
      : `/leads?conversation=${row.id}`;
    navigate(path);
  }

  return (
    <div className="today-panel">
      <div className="today-panel-header">
        <span className="today-panel-title">Call back</span>
        {count > 0 && (
          <span className="today-badge-warn">{count} QUIET</span>
        )}
      </div>
      <div className="today-panel-body">
        {loading ? (
          <div className="today-empty">Checking who went quiet...</div>
        ) : count === 0 ? (
          <div className="today-empty">No one to call back right now.</div>
        ) : (
          rows.map((row) => (
            <div key={row.id} className="today-queue-row">
              <div className="today-queue-row-top">
                <div className="today-queue-title">{row.leadName}</div>
                <span className="today-queue-time">{formatRowTime(new Date(row.lastLeadMessageAt))}</span>
              </div>
              <div className="today-queue-subtext">{row.reason}</div>
              <div className="today-queue-quote">"{row.quote}"</div>
              <div style={{ marginTop: '10px' }}>
                <button type="button" className="inbox-pill-btn-primary" onClick={() => openLead(row)}>
                  Open thread
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
